import script from "./LayersTab.vue?vue&type=script&setup=true&lang=js"
export * from "./LayersTab.vue?vue&type=script&setup=true&lang=js"

import "./LayersTab.vue?vue&type=style&index=0&id=981eb9a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-981eb9a0"]])

export default __exports__